const APP_MODULE_IDS = {
  BILLING: 1,
  SETTINGS_SYNCHRONIZATION: 2,
  CONNECTION_DISCONNECTION_MODULE: 3,
  SSO: 4,
  SWITCH_ORGANIZATION: 5,
  LOGOUT: 951753 // mock id existing only in FE part
}
/**
 * @param {number[]} disabledModules
 * @param {string|number} moduleId
 */
const isModuleDisabled = ({ disabledModules = [], moduleId = 'unknown' } = {}) =>
  disabledModules.includes(moduleId)

const enrichResolvedDisabledModulesForNonWebApp = disabledModules => {
  return [...disabledModules, APP_MODULE_IDS.LOGOUT]
}

module.exports = {
  APP_MODULE_IDS,
  isModuleDisabled,
  enrichResolvedDisabledModulesForNonWebApp
}
